import { PushNotifications } from "@capacitor/push-notifications";
import { Capacitor } from "@capacitor/core";
import api from "./api";

let registrationListener;
let errorListener;

function waitForToken() {
  return new Promise((resolve, reject) => {
    registrationListener?.remove();
    errorListener?.remove();
    PushNotifications.addListener("registration", (token) => {
      resolve(token.value);
    }).then((h) => (registrationListener = h));
    PushNotifications.addListener("registrationError", (err) => {
      reject(new Error(err.error || "Push-Registrierung fehlgeschlagen."));
    }).then((h) => (errorListener = h));
  });
}

export async function nativePushPermission() {
  const { receive } = await PushNotifications.checkPermissions();
  return receive; // "granted" | "denied" | "prompt"
}

export async function enableNativePush() {
  let { receive } = await PushNotifications.checkPermissions();
  if (receive === "prompt" || receive === "prompt-with-rationale") {
    ({ receive } = await PushNotifications.requestPermissions());
  }
  if (receive !== "granted") throw new Error("Benachrichtigungen wurden nicht erlaubt.");

  const tokenPromise = waitForToken();
  await PushNotifications.register();
  const token = await tokenPromise;

  await api.post("/push/register-device", {
    token,
    platform: Capacitor.getPlatform(), // "android" | "ios"
  });
  return true;
}

export async function disableNativePush() {
  try {
    const { receive } = await PushNotifications.checkPermissions();
    if (receive === "granted") {
      // Best-effort: we don't have a stable token without re-registering, so
      // ask the backend to drop tokens for this device/platform on logout of
      // notifications instead of round-tripping through register() again.
      await api.post("/push/unregister-device", { platform: Capacitor.getPlatform() });
    }
  } catch (e) {
    /* ignore */
  }
  await PushNotifications.removeAllDeliveredNotifications();
  return true;
}
